import { render, staticRenderFns } from "./auth-btn.vue?vue&type=template&id=248d9580&scoped=true"
import script from "./auth-btn.vue?vue&type=script&lang=js"
export * from "./auth-btn.vue?vue&type=script&lang=js"
import style0 from "./auth-btn.vue?vue&type=style&index=0&id=248d9580&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d9580",
  null
  
)

export default component.exports